// External libraries
import { isFinite as isUsableNumber } from 'lodash';
import { css } from 'styled-components';

// Zocdoc dependencies
import { GridSize } from '@zocdoc-frontend-common/styles-grid/constants';

// Local imports
import { FontFamily } from '../constants';

const font = fontFamily => (fontSize, lineHeight, paddingTop = 0) => {
    if (!isUsableNumber(paddingTop)) {
        throw new Error(
            'typography/mixins/font: third argument (paddingTop) must be a valid number.'
        );
    }

    let paddingCSS = '';

    if (paddingTop > 0) {
        paddingCSS = css`
            padding-bottom: ${GridSize - paddingTop}px;
            padding-top: ${paddingTop}px;
        `;
    }

    return css`
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-family: ${fontFamily};
        font-size: ${fontSize}px;
        font-style: normal;
        font-weight: normal;
        line-height: ${lineHeight ? `${lineHeight}px` : 'inherit'};
        margin: 0;
        ${paddingCSS}
    `;
};

export const kievitSlabBook = font(FontFamily.KievitSlabBook);
export const sharpSansMedium = font(FontFamily.SharpSansMedium);
export const sharpSansSemibold = font(FontFamily.SharpSansSemibold);
export const sharpSansBold = font(FontFamily.SharpSansBold);
